<template>
<div class="content">

  <div class="header-btn">
    <el-button @click="getExcel">导出</el-button>
<!--    <el-button>导入</el-button>-->
  </div>
<!--  <el-divider></el-divider>-->

  <div class="header-btn">
    <el-badge :value="all_count" class="btn-item">
      <el-link @click="onLabelBtn()">全部</el-link>
    </el-badge>
    <template v-for="(item,index) in label_type_list">
      <el-badge :key="index" :value="item.num" class="btn-item">
        <el-link @click="onLabelBtn(item)">{{ item.name }}</el-link>
      </el-badge>
    </template>
  </div>
  <div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%">
        <el-table-column
          prop="HouseName"
          label="房产" width="300" fixed>
          <template slot-scope="scope">
            <el-link type="primary" size="mini" @click="preView(scope.row)">{{scope.row.HouseName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="业主姓名"
          width="150" fixed>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="业主电话"
          width="180">
        </el-table-column>
        <el-table-column
          prop="butler_name"
          label="催费人员"
          width="100">
        </el-table-column>
        <el-table-column
          prop="type_tip"
          label="催费方式"
          width="90">
        </el-table-column>
        <el-table-column
          prop="send_time"
          label="催费日期"
          width="100">
        </el-table-column>
        <el-table-column
          prop="上次缴费时间"
          label="上次缴费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第一次催费时间"
          label="第一次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第二次催费时间"
          label="第二次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第三次催费时间"
          label="第三次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="添加时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="flow_status"
          label="审核状态"
          width="80">
          <template slot-scope="scope">
            <el-link type="danger" size="mini" v-if="scope.row.flow_status==='驳回'">{{scope.row.flow_status}}</el-link>
            <el-link type="primary" size="mini" v-if="scope.row.flow_status!=='驳回'">{{scope.row.flow_status}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="审批意见"
          width="200">
        </el-table-column>
        <el-table-column
          label="	操作"
          width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="rejectHandel(scope.row)" v-if="scope.row.flow_status!=='驳回'">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>

  <LegalHouseInfo ref="LegalHouseInfo" />

  <el-dialog title="驳回" :visible.sync="dialogVisible2" :close-on-click-modal="false" @close="onClose" width="1000px">

    <div class="view-file-win">
      <el-descriptions v-if="from_data.reason" class="margin-top" :column="2" size="mini" border>
        <el-descriptions-item label="房产">{{ from_data.reason.HouseName }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{ from_data.reason.name }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ from_data.reason.phone }}</el-descriptions-item>
        <el-descriptions-item label="欠费类型">{{ from_data.reason.arrears_type }}</el-descriptions-item>
<!--        <el-descriptions-item label="欠费原因">{{ from_data.reason.arrears_reason }}</el-descriptions-item>-->
        <el-descriptions-item :label="from_data.reason.type==5&&from_data.reason.type_ex==2?'诉调案号':(from_data.reason.type==5&&from_data.reason.type_ex==3?'受理案件号':'业主诉求')">{{ from_data.reason.user_appeal }}</el-descriptions-item>
        <el-descriptions-item label="催缴措施">{{ from_data.reason.measures }}</el-descriptions-item>
        <el-descriptions-item label="预计回款时间">{{ from_data.reason.ymd }}</el-descriptions-item>
        <el-descriptions-item label="催缴责任人">{{ from_data.reason.user_person_liable }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ from_data.reason.remarks }}</el-descriptions-item>
        <el-descriptions-item label="添加时间">{{ from_data.reason.created_at }}</el-descriptions-item>
      </el-descriptions>
      <div class="main-log">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入驳回理由 "
          v-model="textarea">
        </el-input>
      </div>
    </div>
    <template slot="footer">
      <div>
        <el-button icon="el-icon-close" @click="dialogVisible2=false">关 闭</el-button>
        <el-button @click="rejectSubmit">确 认</el-button>
      </div>
    </template>
  </el-dialog>
</div>
</template>

<script>
import moment from "moment/moment";
import LegalHouseInfo from "../LegalHouseInfo";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdPartyLitigationTab4",
  components: {LegalHouseInfo},
  data(){
    return{
      where: {
        text:"",
        type:"",
        type_ex:"",
        start_time:moment(new Date()).format("YYYY-MM-DD"),
        end_time:moment(new Date()).format("YYYY-MM-DD")
      },
      label_type_list:[
        // {type:5,name:"全 部"},
        {type:14,name:"诉讼（提交）",type_ex:5},
        {type:14,name:"诉讼（诉调）",type_ex:52},
        {type:14,name:"诉讼（立案）",type_ex:53},
        {type:10,name:"成功催缴",type_ex:1405},
      ],
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      all_count:0,
      from_data:{},
      loading: false,
      batch_number:"",
      dialogVisible2:false,
      textarea:"",
      log_id:""
    }
  },
  mounted() {
    this.batch_number=this.$route.query.batch_number
    this.getList()
    this.getAjaxCount()
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      where={
        ...where,
        batch_number:that.batch_number,
      }
      ButlerHttp.post("ThirdPartyLitigation/getBatchNumberList", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getExcel() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      where={
        ...where,
        batch_number:that.batch_number,
      }
      ButlerHttp.post("ThirdPartyLitigation/getBatchNumberExcel", {
        ...where
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        }
        that.loading = false;
      });
    },
    getAjaxCount(){
      const that = this;
      let where = {batch_number:that.batch_number,}
      ButlerHttp.post("ThirdPartyLitigation/getBatchNumberListCount", where, res => {
        if (res.code) {
          let label_type_list = that.label_type_list;
          label_type_list = label_type_list.map(ret => {
            let item_list = res.data.filter(r => {
              if (ret.type_ex !== undefined) {
                return ret.type == r.type && ret.type_ex == r.type_ex;
              } else {
                return ret.type == r.type;
              }
            });
            ret.num = item_list.reduce((prev, cur) => prev + cur.count, 0);
            return ret;
          });
          that.label_type_list = label_type_list;
          that.type_list = res.data;
          that.all_count = res.data.reduce((p, n) => p + n.count, 0);
        }
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    onLabelBtn(item=null){
      this.where.type=(item||{}).type||"";
      this.where.type_ex=(item||{}).type_ex||"";
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
    },
    preView(item){
      this.$refs.LegalHouseInfo.show(item)
    },
    onClose(){
      this.dialogVisible2=false;
      this.from_data={};
    },
    startFlow(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("ThirdPartyLitigation/getBatchNumber", where, res => {
        if (res.code) {
          let timeValue = new Date().getTime();
          ERP.navigateTo("/flow/FlowView?sheet_id=66&master_id=63&batch_number=" + res.data + '&timeValue=' + timeValue);
        } else {
          that.$message.error(res.msg || '批次号获取异常');
        }
      });
    },
    rejectHandel(item){
      const that=this;
      ButlerHttp.get("Legal/getDetails", {
        precinctid: item.project_house_id,
        houseid: item.house_id
      }, res => {
        if (res.code) {
          that.dialogVisible2 = true;
          res.data.reason.type = item.type;
          res.data.reason.type_ex = item.type_ex;
          that.from_data = {
            flow_id: item.id,
            ...res.data
          };
        } else {
          that.$message.error(res.msg || "无法访问");
        }
      });
    },
    rejectSubmit(){
      const that=this;
      ButlerHttp.post("ThirdPartyLitigation/rejectSave", {
        id: that.from_data.flow_id,
        textarea: that.textarea
      }, res => {
        if (res.code) {
          that.dialogVisible2 = false;
          that.getList();
        } else {
          that.$message.error(res.msg || "操作异常");
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  background-color: #FFFFFF;
  padding: 10px 20px;

  .header-btn{
    .btn-item{
      margin: 5px 20px;
    }
    margin-bottom: 10px;
  }

  .pagination-wrap {
    margin-top: 10px;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationTab4.vue